/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { MasterImportResponse } from '../model/masterImportResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class FinanceDataSyncControllerService {

    protected basePath = 'https://localhost:8080/nrfsi/nissan';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingDELETE3(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingDELETE3(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingDELETE3(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingDELETE3(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<Array<MasterImportResponse>>(`${this.basePath}/import/finance/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingGET3(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingGET3(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingGET3(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingGET3(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<MasterImportResponse>>(`${this.basePath}/import/finance/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingHEAD3(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingHEAD3(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingHEAD3(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingHEAD3(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<Array<MasterImportResponse>>(`${this.basePath}/import/finance/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingOPTIONS3(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingOPTIONS3(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingOPTIONS3(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingOPTIONS3(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<Array<MasterImportResponse>>(`${this.basePath}/import/finance/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingPATCH3(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingPATCH3(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingPATCH3(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingPATCH3(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<Array<MasterImportResponse>>(`${this.basePath}/import/finance/all`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingPOST3(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingPOST3(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingPOST3(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingPOST3(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<Array<MasterImportResponse>>(`${this.basePath}/import/finance/all`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingPUT3(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingPUT3(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingPUT3(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingPUT3(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<Array<MasterImportResponse>>(`${this.basePath}/import/finance/all`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinProdMaxPayOut
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinProdMaxPayOutUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinProdMaxPayOutUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinProdMaxPayOutUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinProdMaxPayOutUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/finance/prodMaxpayOut`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinProdMaxPayOut
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinProdMaxPayOutUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinProdMaxPayOutUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinProdMaxPayOutUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinProdMaxPayOutUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/finance/prodMaxpayOut`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinProdMaxPayOut
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinProdMaxPayOutUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinProdMaxPayOutUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinProdMaxPayOutUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinProdMaxPayOutUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/finance/prodMaxpayOut`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinProdMaxPayOut
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinProdMaxPayOutUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinProdMaxPayOutUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinProdMaxPayOutUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinProdMaxPayOutUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/finance/prodMaxpayOut`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinProdMaxPayOut
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinProdMaxPayOutUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinProdMaxPayOutUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinProdMaxPayOutUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinProdMaxPayOutUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/finance/prodMaxpayOut`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinProdMaxPayOut
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinProdMaxPayOutUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinProdMaxPayOutUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinProdMaxPayOutUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinProdMaxPayOutUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/finance/prodMaxpayOut`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinProdMaxPayOut
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinProdMaxPayOutUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinProdMaxPayOutUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinProdMaxPayOutUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinProdMaxPayOutUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/finance/prodMaxpayOut`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinProdRoi
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinProdRoiUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinProdRoiUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinProdRoiUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinProdRoiUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/finance/roiProduct`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinProdRoi
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinProdRoiUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinProdRoiUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinProdRoiUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinProdRoiUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/finance/roiProduct`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinProdRoi
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinProdRoiUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinProdRoiUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinProdRoiUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinProdRoiUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/finance/roiProduct`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinProdRoi
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinProdRoiUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinProdRoiUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinProdRoiUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinProdRoiUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/finance/roiProduct`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinProdRoi
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinProdRoiUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinProdRoiUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinProdRoiUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinProdRoiUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/finance/roiProduct`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinProdRoi
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinProdRoiUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinProdRoiUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinProdRoiUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinProdRoiUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/finance/roiProduct`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinProdRoi
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinProdRoiUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinProdRoiUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinProdRoiUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinProdRoiUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/finance/roiProduct`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinSplPgmMaxPayOut
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinSplPgmMaxPayOutUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinSplPgmMaxPayOutUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinSplPgmMaxPayOutUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinSplPgmMaxPayOutUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/finance/splpgmMaxpayOut`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinSplPgmMaxPayOut
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinSplPgmMaxPayOutUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinSplPgmMaxPayOutUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinSplPgmMaxPayOutUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinSplPgmMaxPayOutUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/finance/splpgmMaxpayOut`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinSplPgmMaxPayOut
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinSplPgmMaxPayOutUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinSplPgmMaxPayOutUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinSplPgmMaxPayOutUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinSplPgmMaxPayOutUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/finance/splpgmMaxpayOut`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinSplPgmMaxPayOut
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinSplPgmMaxPayOutUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinSplPgmMaxPayOutUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinSplPgmMaxPayOutUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinSplPgmMaxPayOutUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/finance/splpgmMaxpayOut`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinSplPgmMaxPayOut
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinSplPgmMaxPayOutUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinSplPgmMaxPayOutUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinSplPgmMaxPayOutUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinSplPgmMaxPayOutUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/finance/splpgmMaxpayOut`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinSplPgmMaxPayOut
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinSplPgmMaxPayOutUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinSplPgmMaxPayOutUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinSplPgmMaxPayOutUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinSplPgmMaxPayOutUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/finance/splpgmMaxpayOut`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinSplPgmMaxPayOut
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinSplPgmMaxPayOutUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinSplPgmMaxPayOutUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinSplPgmMaxPayOutUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinSplPgmMaxPayOutUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/finance/splpgmMaxpayOut`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinSplPgmRoi
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinSplPgmRoiUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinSplPgmRoiUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinSplPgmRoiUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinSplPgmRoiUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/finance/roiSplPgm`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinSplPgmRoi
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinSplPgmRoiUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinSplPgmRoiUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinSplPgmRoiUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinSplPgmRoiUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/finance/roiSplPgm`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinSplPgmRoi
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinSplPgmRoiUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinSplPgmRoiUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinSplPgmRoiUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinSplPgmRoiUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/finance/roiSplPgm`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinSplPgmRoi
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinSplPgmRoiUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinSplPgmRoiUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinSplPgmRoiUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinSplPgmRoiUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/finance/roiSplPgm`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinSplPgmRoi
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinSplPgmRoiUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinSplPgmRoiUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinSplPgmRoiUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinSplPgmRoiUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/finance/roiSplPgm`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinSplPgmRoi
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinSplPgmRoiUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinSplPgmRoiUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinSplPgmRoiUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinSplPgmRoiUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/finance/roiSplPgm`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinSplPgmRoi
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinSplPgmRoiUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinSplPgmRoiUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinSplPgmRoiUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinSplPgmRoiUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/finance/roiSplPgm`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinprodSubprodRecovMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinprodSubprodRecovMapUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinprodSubprodRecovMapUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinprodSubprodRecovMapUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinprodSubprodRecovMapUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/finance/indFinprodSubprodRecovMap`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinprodSubprodRecovMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinprodSubprodRecovMapUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinprodSubprodRecovMapUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinprodSubprodRecovMapUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinprodSubprodRecovMapUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/finance/indFinprodSubprodRecovMap`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinprodSubprodRecovMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinprodSubprodRecovMapUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinprodSubprodRecovMapUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinprodSubprodRecovMapUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinprodSubprodRecovMapUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/finance/indFinprodSubprodRecovMap`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinprodSubprodRecovMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinprodSubprodRecovMapUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinprodSubprodRecovMapUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinprodSubprodRecovMapUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinprodSubprodRecovMapUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/finance/indFinprodSubprodRecovMap`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinprodSubprodRecovMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinprodSubprodRecovMapUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinprodSubprodRecovMapUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinprodSubprodRecovMapUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinprodSubprodRecovMapUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/finance/indFinprodSubprodRecovMap`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinprodSubprodRecovMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinprodSubprodRecovMapUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinprodSubprodRecovMapUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinprodSubprodRecovMapUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinprodSubprodRecovMapUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/finance/indFinprodSubprodRecovMap`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importFinprodSubprodRecovMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importFinprodSubprodRecovMapUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importFinprodSubprodRecovMapUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importFinprodSubprodRecovMapUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importFinprodSubprodRecovMapUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/finance/indFinprodSubprodRecovMap`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndFinSplPgm
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndFinSplPgmUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndFinSplPgmUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndFinSplPgmUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndFinSplPgmUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/finance/splpgm`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndFinSplPgm
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndFinSplPgmUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndFinSplPgmUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndFinSplPgmUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndFinSplPgmUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/finance/splpgm`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndFinSplPgm
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndFinSplPgmUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndFinSplPgmUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndFinSplPgmUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndFinSplPgmUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/finance/splpgm`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndFinSplPgm
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndFinSplPgmUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndFinSplPgmUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndFinSplPgmUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndFinSplPgmUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/finance/splpgm`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndFinSplPgm
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndFinSplPgmUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndFinSplPgmUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndFinSplPgmUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndFinSplPgmUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/finance/splpgm`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndFinSplPgm
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndFinSplPgmUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndFinSplPgmUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndFinSplPgmUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndFinSplPgmUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/finance/splpgm`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndFinSplPgm
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndFinSplPgmUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndFinSplPgmUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndFinSplPgmUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndFinSplPgmUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/finance/splpgm`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndFinanceProduct
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndFinanceProductUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndFinanceProductUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndFinanceProductUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndFinanceProductUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/finance/indfinanceproduct`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndFinanceProduct
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndFinanceProductUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndFinanceProductUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndFinanceProductUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndFinanceProductUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/finance/indfinanceproduct`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndFinanceProduct
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndFinanceProductUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndFinanceProductUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndFinanceProductUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndFinanceProductUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/finance/indfinanceproduct`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndFinanceProduct
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndFinanceProductUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndFinanceProductUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndFinanceProductUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndFinanceProductUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/finance/indfinanceproduct`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndFinanceProduct
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndFinanceProductUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndFinanceProductUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndFinanceProductUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndFinanceProductUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/finance/indfinanceproduct`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndFinanceProduct
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndFinanceProductUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndFinanceProductUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndFinanceProductUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndFinanceProductUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/finance/indfinanceproduct`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndFinanceProduct
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndFinanceProductUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndFinanceProductUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndFinanceProductUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndFinanceProductUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/finance/indfinanceproduct`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importRecoveryModeTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importRecoveryModeTypcodeUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importRecoveryModeTypcodeUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importRecoveryModeTypcodeUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importRecoveryModeTypcodeUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/finance/indRecoveryModeTypcode`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importRecoveryModeTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importRecoveryModeTypcodeUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importRecoveryModeTypcodeUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importRecoveryModeTypcodeUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importRecoveryModeTypcodeUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/finance/indRecoveryModeTypcode`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importRecoveryModeTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importRecoveryModeTypcodeUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importRecoveryModeTypcodeUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importRecoveryModeTypcodeUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importRecoveryModeTypcodeUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/finance/indRecoveryModeTypcode`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importRecoveryModeTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importRecoveryModeTypcodeUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importRecoveryModeTypcodeUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importRecoveryModeTypcodeUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importRecoveryModeTypcodeUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/finance/indRecoveryModeTypcode`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importRecoveryModeTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importRecoveryModeTypcodeUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importRecoveryModeTypcodeUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importRecoveryModeTypcodeUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importRecoveryModeTypcodeUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/finance/indRecoveryModeTypcode`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importRecoveryModeTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importRecoveryModeTypcodeUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importRecoveryModeTypcodeUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importRecoveryModeTypcodeUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importRecoveryModeTypcodeUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/finance/indRecoveryModeTypcode`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importRecoveryModeTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importRecoveryModeTypcodeUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importRecoveryModeTypcodeUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importRecoveryModeTypcodeUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importRecoveryModeTypcodeUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/finance/indRecoveryModeTypcode`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSubproductGrpMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSubproductGrpMapUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSubproductGrpMapUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSubproductGrpMapUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSubproductGrpMapUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/finance/subproductGrpMap`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSubproductGrpMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSubproductGrpMapUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSubproductGrpMapUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSubproductGrpMapUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSubproductGrpMapUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/finance/subproductGrpMap`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSubproductGrpMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSubproductGrpMapUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSubproductGrpMapUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSubproductGrpMapUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSubproductGrpMapUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/finance/subproductGrpMap`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSubproductGrpMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSubproductGrpMapUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSubproductGrpMapUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSubproductGrpMapUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSubproductGrpMapUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/finance/subproductGrpMap`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSubproductGrpMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSubproductGrpMapUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSubproductGrpMapUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSubproductGrpMapUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSubproductGrpMapUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/finance/subproductGrpMap`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSubproductGrpMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSubproductGrpMapUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSubproductGrpMapUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSubproductGrpMapUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSubproductGrpMapUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/finance/subproductGrpMap`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSubproductGrpMap
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSubproductGrpMapUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSubproductGrpMapUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSubproductGrpMapUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSubproductGrpMapUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/finance/subproductGrpMap`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSubproductGrp
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSubproductGrpUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSubproductGrpUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSubproductGrpUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSubproductGrpUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/finance/subproductGrp`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSubproductGrp
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSubproductGrpUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSubproductGrpUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSubproductGrpUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSubproductGrpUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/finance/subproductGrp`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSubproductGrp
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSubproductGrpUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSubproductGrpUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSubproductGrpUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSubproductGrpUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/finance/subproductGrp`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSubproductGrp
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSubproductGrpUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSubproductGrpUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSubproductGrpUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSubproductGrpUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/finance/subproductGrp`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSubproductGrp
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSubproductGrpUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSubproductGrpUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSubproductGrpUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSubproductGrpUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/finance/subproductGrp`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSubproductGrp
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSubproductGrpUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSubproductGrpUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSubproductGrpUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSubproductGrpUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/finance/subproductGrp`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSubproductGrp
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSubproductGrpUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSubproductGrpUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSubproductGrpUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSubproductGrpUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/finance/subproductGrp`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSubproduct
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSubproductUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSubproductUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSubproductUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSubproductUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/finance/indSubProduct`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSubproduct
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSubproductUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSubproductUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSubproductUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSubproductUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/finance/indSubProduct`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSubproduct
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSubproductUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSubproductUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSubproductUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSubproductUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/finance/indSubProduct`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSubproduct
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSubproductUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSubproductUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSubproductUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSubproductUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/finance/indSubProduct`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSubproduct
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSubproductUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSubproductUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSubproductUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSubproductUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/finance/indSubProduct`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSubproduct
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSubproductUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSubproductUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSubproductUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSubproductUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/finance/indSubProduct`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importSubproduct
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importSubproductUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importSubproductUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importSubproductUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importSubproductUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/finance/indSubProduct`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
